import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { Contact } from 'contact/contact';
import { ContactModuleColumn } from 'contact/contact-module-column';
import { ContactNote } from 'contact/contact-note';
import { ContactModuleColumnOutput } from 'contact/model/contact-module-column.output';
import { ContactNoteOutput } from 'contact/model/contact-note.output';
import { ContactOutput } from 'contact/model/contact.output';
import { ContactConverterPort } from 'contact/port/contact-converter.port';

@Injectable()
export class ContactConverterAdapter implements ContactConverterPort {
	public contactModuleColumnAsEntity(
		output: ContactModuleColumnOutput
	): ContactModuleColumn {
		if (!output) {
			return null;
		}

		return new ContactModuleColumn(output.columnId, output.moduleId);
	}

	public contactModuleColumnsAsEntities(
		outputs: ContactModuleColumnOutput[]
	): ContactModuleColumn[] {
		return reject(outputs, isNil).map((output) =>
			this.contactModuleColumnAsEntity(output)
		);
	}

	public contactNoteAsEntity(output: ContactNoteOutput): ContactNote {
		if (!output) {
			return null;
		}

		return new ContactNote(output.taskId, output.note, output.creationTimestamp);
	}

	public contactNotesAsEntities(outputs: ContactNoteOutput[]): ContactNote[] {
		return reject(outputs, isNil).map((output) =>
			this.contactNoteAsEntity(output)
		);
	}

	public contactAsEntity(output: ContactOutput): Contact {
		if (!output) {
			return null;
		}

		return new Contact(
			output.id,
			output.name,
			output.ownerId,
			output.language,
			output.phoneNumber,
			output.companies,
			output.categories,
			output.emailAddress,
			output.updateTimestamp,
			output.creationTimestamp,
			output.lastMeetingTimestamp,
			this.contactNotesAsEntities(output.notes),
			this.contactModuleColumnsAsEntities(output.modulesColumn)
		);
	}

	public contactsAsEntities(outputs: ContactOutput[]): Contact[] {
		return reject(outputs, isNil).map((output) => this.contactAsEntity(output));
	}
}
